// src/components/TrumpSelector.jsx
import React, { useContext, useState } from 'react';
import { GameContext } from '../context/GameContext';

const TrumpSelector = () => {
  const { gameState, socket } = useContext(GameContext);
  const playerId = socket.id;
  const callerId = gameState?.state?.caller;
  const player = gameState.players.find(p => p.socketId === playerId);
  const isCaller = player?.id === callerId;

  const [selectedCard, setSelectedCard] = useState(null);

  const handleSelectTrump = (card) => {
    socket.emit('selectTrump', {
      gameId: gameState.id,
      playerId: player.id,
      trumpCard: card,
    });
  };

  if (!isCaller) {
    return <p className="text-sm text-gray-500">Waiting for caller to select trump...</p>;
  }

  return (
    <div className="p-4 bg-yellow-50 rounded-lg shadow">
      <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '16px', textAlign: 'center' }}>
        Select Trump Card
      </h3>

      <p style={{ fontSize: '1.1rem', marginBottom: '16px', textAlign: 'center', color: '#92400e' }}>
        Choose one card to set aside as trump (it will be hidden until revealed)
      </p>

      {/* Show player's cards as clickable buttons */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '12px',
        justifyContent: 'center',
        padding: '8px'
      }}>
        {player?.hand?.map((card, idx) => {
          const isRed = card.suit === '♥' || card.suit === '♦';
          const isSelected = selectedCard && selectedCard.suit === card.suit && selectedCard.value === card.value;
          return (
            <button
              key={idx}
              onClick={() => {
                setSelectedCard(card);
                handleSelectTrump(card);
              }}
              style={{
                backgroundColor: isSelected ? '#fbbf24' : 'white',
                border: `3px solid ${isSelected ? '#d97706' : (isRed ? '#dc2626' : '#000000')}`,
                borderRadius: '12px',
                padding: '16px 20px',
                minWidth: '80px',
                minHeight: '100px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                cursor: 'pointer',
                transition: 'all 0.2s',
                color: isRed ? '#dc2626' : '#000000',
                fontFamily: 'Arial, sans-serif',
                fontSize: '32px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onMouseEnter={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.backgroundColor = '#fef3c7';
                  e.currentTarget.style.transform = 'scale(1.05)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.backgroundColor = 'white';
                  e.currentTarget.style.transform = 'scale(1)';
                }
              }}
            >
              {card.value}{card.suit}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TrumpSelector;
